export default "__VITE_ASSET__BGejp0pS__"